import { ReactNode } from "react";
import ConnectionStatusBadge from "./ConnectionStatusBadge";

interface SectionHeaderProps {
  title: string;
  isConnected?: boolean;
  statusBadges?: ReactNode[];
  actions?: ReactNode[];
  className?: string;
}

/**
 * Section Header Component
 * Displays section title with optional status badges and action buttons
 */
export default function SectionHeader({
  title,
  isConnected,
  statusBadges = [],
  actions = [],
  className = "",
}: SectionHeaderProps) {
  return (
    <div className={`hooks-test-section-header-flex ${className}`}>
      <h2 className="hooks-test-section-header-title">{title}</h2>
      <div className="hooks-test-status-group">
        {isConnected !== undefined && (
          <ConnectionStatusBadge isConnected={isConnected} />
        )}
        {statusBadges.map((badge, idx) => (
          <span key={idx}>{badge}</span>
        ))}
        {actions.map((action, idx) => (
          <span key={idx}>{action}</span>
        ))}
      </div>
    </div>
  );
}
